define('views/modules/calendar/nutrition/calories/calorie-goal',[
    // Libs
    'underscore', 'backbone', 'mustache',

    // events
    'services/events/nutrition-events',
    'services/events/user-events',

    // templates
    'text!templates/modules/calendar/nutrition/calories/calorie-goal.html'
], function(
    // Libs
    _, Backbone, Mustache,

    //
    NutritionEvents,
    UserEvents,

    // templates
    TCalorieGoal
) {

    var VCalorieGoal = Backbone.View.extend({
        template: TCalorieGoal,

        events: {
            "click .open-client-settings": "onClickAddCalorieGoal"
        },

        initialize: function(opt) {
            this.options = opt;
            this.model = opt.profile;
            this.goal = this.getCalorieGoal();
            this.collection = opt.collection;
            this.calories = null;
            this.percentage = null;

            this.listenTo(this.collection, 'change update reset', this.onUpdate);
            this.listenTo(UserEvents, 'profile:update', this.updateGoalTarget);
        },

        render: function() {
            var percent = Math.round(this.percentage);
            var percentText = percent;
            var indicator = this.getColorIndicator(percent);

            if (percent >= 100) percent = 100;

            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext(
                _.extend(this.options, {
                    caloriesPercentage: percent,
                    caloriesPercentageText: percentText,
                    colorIndicator: indicator,
                    goal: this.goal,
                    isSupervisor: this.options.isSupervisor,
                    calories: Math.round(this.calories),
                })
            )));
            return this;
        },

        getCalorieGoal: function() {
          return _.isEmpty(this.options.profile.get('calorie_goal')) ? this.getDefaultCalorieGoal() : this.options.profile.get('calorie_goal');
        },

        getPercentage: function() {
            return this.calories * 100 / this.goal;
        },

        getColorIndicator: function(percent) {
            if (percent <= 100) return false;
            if (percent >= 100 && percent <= 120) return "warning";
            if (percent > 120) return "alert";
        },

        getDefaultCalorieGoal: function() {
            return this.options.profile.getDefaultCalorieGoal();
        },


        // Events

        onUpdate: function() {
            this.goal = this.getCalorieGoal();
            this.calories = _.roundTo(this.collection.getCalories(), 1);
            this.percentage = this.getPercentage();
            this.render();
        },

        onClickAddCalorieGoal: function(event) {
            event.stopPropagation();
            event.preventDefault();
            NutritionEvents.defineClientCalorieGoalTarget(this.model);
        },

        updateGoalTarget: function(model) {
            if (_.isEmpty(model.get('calorie_goal'))) {
              this.goal = this.getDefaultCalorieGoal();
            } else {
              this.goal = parseInt(model.get('calorie_goal'));
            }
            this.percentage = this.getPercentage();
            this.render();
        }
    });

    return VCalorieGoal;
});

